(function () {

  'use strict';

  angular
  .module('mgpCorregedoriaApp.validacao')
  .controller('RelatorioVistaAbertaPromotor', RelatorioVistaAbertaPromotor);

  function RelatorioVistaAbertaPromotor(DataService,  toaster, i18n,
    FiltroRelatorio30DiasValidator, PeriodoService, $state,
    RelatorioVistaAbertaPromotorService, ngsalConfig, PromotorService) {

      var vm = this;

      vm.init = init;
      vm.convertDate = convertDate;
      vm.filtrarRelatorioVistaAberta = filtrarRelatorioVistaAberta;
      vm.calcularTotaisEPreparaGrafico = calcularTotaisEPreparaGrafico;
      vm.voltarRelatorioVistaAbertaCorregedoria = voltarRelatorioVistaAbertaCorregedoria;
      vm.consultarPromotor = consultarPromotor;

      vm.versionApi = ngsalConfig.apiVersion;

      vm.nomePromotor = '';
      vm.promotorSelecionado = {
        originalObject : {}
      };
      vm.colors = ['#016FB0','#2C3E50', '#924AB0'];

      vm.init();

      function convertDate(date) {
        return  DataService.convertDate(date);
      }

      function init() {
        vm.periodoRelatorioEnviadoList = PeriodoService.loadPeriodosFiltro();

        if ($state.params.periodoInicial !== '' && $state.params.periodoFinal !== '') {
          vm.periodoInicial = $state.params.periodoInicial;
          vm.periodoFinal =  $state.params.periodoFinal;
          vm.nomePromotor =  $state.params.nomePromotor;
          vm.pessDk =  $state.params.pessDk;
          vm.exibeBotaoVoltar = true;
          filtrarRelatorioVistaAberta();

        }

      }

      function consultarPromotor(query, timeoutPromise) {
        return PromotorService.consultarPromotor(query, timeoutPromise);
      }

      function filtrarRelatorioVistaAberta() {

        if (vm.nomePromotor !== '') {
          vm.nomePromotorSelecionado = vm.nomePromotor;
        }

        if (vm.promotorSelecionado && vm.promotorSelecionado.originalObject && vm.promotorSelecionado.originalObject.nomePromotor) {
          vm.nomePromotor =  vm.promotorSelecionado.originalObject.nomePromotor;
          vm.nomePromotorSelecionado = vm.promotorSelecionado.originalObject.nomePromotor;
          vm.pessDk = vm.promotorSelecionado.originalObject.pessDk;
        }

        vm.filter = {
          periodoInicial: vm.periodoInicial,
          periodoFinal: vm.periodoFinal,
          nomePromotor: vm.nomePromotor,
          pessDk: vm.pessDk,
          tipo : "Promotor",
          frequencia:null
        };

        var erros = FiltroRelatorio30DiasValidator.getErrors(vm.filter);
        erros.map(function (erro) {
          toaster.pop('error', i18n.translate(erro));
        });

        if (!erros.length) {

          RelatorioVistaAbertaPromotorService.retornaRelatorioVistaAbertaPromotor(vm.filter).then(function (data) {
            vm.feitosByPromotoresList = data;

            if (vm.feitosByPromotoresList === null || vm.feitosByPromotoresList.length === 0){
              toaster.pop('error', i18n.translate('relatorio.vista.aberta'), i18n.translate('label.nao.existem.registros'));
            }else{
              calcularTotaisEPreparaGrafico();
            }
          });
        }
      }

      function voltarRelatorioVistaAbertaCorregedoria(){
        $state.go('relatorioVistaAbertaCorregedoria',{
          referer:'botaoVoltar',
          filtros:$state.params.filtros
        });
      }

      function calcularTotaisEPreparaGrafico(){
        var x = 0 ;

        vm.totalReconhecido = 0;
        vm.totalImpugnado = 0;
        vm.totalSemJustificativa = 0;
        vm.meses = [];
        vm.listaReconhecido = [];
        vm.listaImpugnado = [];
        vm.listaSemJustificativa = [];

        for( ; vm.feitosByPromotoresList.length > x ; x++){
          vm.totalReconhecido += vm.feitosByPromotoresList[x].totalReconhecidos;
          vm.totalImpugnado += vm.feitosByPromotoresList[x].totalImpugnados;
          vm.totalSemJustificativa += vm.feitosByPromotoresList[x].totalSemJustificativa;

          vm.meses [x] = convertDate(vm.feitosByPromotoresList[x].mes);

          vm.listaReconhecido [x] = vm.feitosByPromotoresList[x].totalReconhecidos;
          vm.listaImpugnado [x] = vm.feitosByPromotoresList[x].totalImpugnados;
          vm.listaSemJustificativa [x] = vm.feitosByPromotoresList[x].totalSemJustificativa;
        }

        vm.listaTotais = [vm.totalReconhecido, vm.totalImpugnado, vm.totalSemJustificativa];
        vm.titulosTotais = ["Reconhecido", "Impugnado", "SemJustificativa"];

        vm.quantidadePorMes = [vm.listaReconhecido,vm.listaImpugnado,vm.listaSemJustificativa];
      }
    }

  })();
